import React from "react";
import TransportationDistrubution from "./TransportationDistrubution";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../../context/AuthContext";
const Air = () => {
   const{user}=useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope3Layout />}>
      <Unauthorized requiredModule="Environment | Scope 3 | Transportation distribution">
        <TransportationDistrubution />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Air;
